module.exports = __webpack_public_path__ + "img/imageGalery10.0545ce93.jpg";